import { render, staticRenderFns } from "./DefaultDashboard.vue?vue&type=template&id=07303961&scoped=true"
import script from "./DefaultDashboard.vue?vue&type=script&lang=js"
export * from "./DefaultDashboard.vue?vue&type=script&lang=js"
import style0 from "./DefaultDashboard.vue?vue&type=style&index=0&id=07303961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07303961",
  null
  
)

export default component.exports